import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API_BASE from "../config/api";

export default function UpgradeListing({ listinguid }) {


    const navigate = useNavigate();

    // Payment result from gateway redirect
    const [searchParams] = useSearchParams();
    const paymentStatus = searchParams.get("payment"); // success | failed

    const localUser = JSON.parse(localStorage.getItem("user"));
    const personaluid = localUser?.personaluid;

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([]);
    const [promotionDays, setPromotionDays] = useState(0);
    const [loading, setLoading] = useState(false);

    const [purchased, setPurchased] = useState([]);
    const [purchasedPromo, setPurchasedPromo] = useState(null);
    const [owned, setOwned] = useState([]);
    const [upgradeRefreshKey, setUpgradeRefreshKey] = useState(0);
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState("bank");
    const [walletBalance, setWalletBalance] = useState(0);



    const getPlanKey = (title = "") => {
        const t = title.toLowerCase();

        if (t.includes("verified")) return "verified_user";
        if (t.includes("term")) return "term_insurance";
        if (t.includes("personal")) return "personal_portfolio";
        if (t.includes("website")) return "website_link";
        if (t.includes("sms")) return "sms_panel";

        return null;
    };
    const getFilteredSelectedPlans = () => {
        return selected.filter(id => {
            const opt = options.find(o => o.id === id);
            if (!opt) return false;
            if (owned.some(o => o.id === id)) return false;

            const planKey = getPlanKey(opt.title);
            return !purchased.some(p => p.key === planKey);
        });
    };


    useEffect(() => {
        if (!listinguid || options.length === 0) return;

        fetch(`${API_BASE}/api/get_listing_upgrades.php?listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (!data.success) return;

                setPurchased(data.packages || []);
                  setOwned(data.owned || []);

                const alreadySelected = data.packages
                    .map(p => {
                        const opt = options.find(o => getPlanKey(o.title) === p.key);
                        return opt?.id;
                    })
                    .filter(Boolean);



                if (data.promotion) {
                    setPromoStartDate(data.promotion.start.split(" ")[0]);
                    setPromoEndDate(data.promotion.end.split(" ")[0]);
                    setPurchasedPromo(data.promotion);
                }
            });
    }, [listinguid, options]);
     const isPackagePurchased = (plan) => {
        const planKey = getPlanKey(plan.title);
        return (planKey && purchased.some(p => p.key === planKey)) || owned.some(o => o.id === plan.id);
    };




    const [promoStartDate, setPromoStartDate] = useState("");
    const [promoEndDate, setPromoEndDate] = useState("");



    useEffect(() => {
        // promotion already purchased -> force 0
        if (purchasedPromo) {
            setPromotionDays(0);
            return;
        }

        if (!promoStartDate || !promoEndDate) {
            setPromotionDays(0);
            return;
        }

        const start = new Date(promoStartDate + "T00:00:00");
        const end = new Date(promoEndDate + "T00:00:00");

        if (end < start) {
            setPromotionDays(0);
            return;
        }

        const diffTime = end - start;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

        setPromotionDays(diffDays);
    }, [promoStartDate, promoEndDate, purchasedPromo]);

    useEffect(() => {
        if (!listinguid) return;

        fetch(`${API_BASE}/api/get_wallet.php?user_id=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setWalletBalance(Number(data.balance) || 0);
                }
            })
            .catch(() => setWalletBalance(0));
    }, [listinguid]);



    useEffect(() => {
        if (paymentStatus) {
            const url = new URL(window.location.href);
            url.searchParams.delete("payment");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus]);

    const [toast, setToast] = useState({
        show: false,
        message: "",
        type: "success", // success | danger | info
        duration: 3000
    });

    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => {
                setToast(prev => ({ ...prev, show: false }));
            }, toast.duration);

            return () => clearTimeout(timer);
        }
    }, [toast.show, toast.duration]);

    /* ----------------------------------------
       PAYMENT RESULT HANDLING
    ---------------------------------------- */

    const refreshAfterPayment = () => {
        // refresh upgrades
        fetch(`${API_BASE}/api/get_listing_upgrades.php?listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (!data.success) return;

                setPurchased(data.packages || []);
                  setOwned(data.owned || []);
                setPurchasedPromo(data.promotion || null);

                const alreadySelected = data.packages
                    .map(p => {
                        const opt = options.find(o => getPlanKey(o.title) === p.key);
                        return opt?.id;
                    })
                    .filter(Boolean);

                setSelected(alreadySelected);
            });

        // refresh payment history
        fetch(`${API_BASE}/api/get_payment_history.php?listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) setPaymentHistory(data.history);
            });

        // refresh wallet balance
        fetch(`${API_BASE}/api/get_wallet.php?user_id=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) setWalletBalance(Number(data.balance) || 0);
            });
    };


    useEffect(() => {
        if (paymentStatus === "success" && listinguid) {

            // show toast
            setToast({
                show: true,
                message: "Payment successful! Listing upgraded",
                type: "success",
                duration: 3500,
            });

            // refetch & auto-lock
            fetch(`${API_BASE}/api/get_listing_upgrades.php?listinguid=${listinguid}`)
                .then(res => res.json())
                .then(data => {
                    if (!data.success) return;
                    setPurchased(data.packages || []);
                      setOwned(data.owned || []);
                    setPurchasedPromo(data.promotion || null);
                });

            // clean url
            const url = new URL(window.location.href);
            url.searchParams.delete("payment");
            url.searchParams.delete("page");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus, listinguid]);








    /* ----------------------------------------
       LOAD PACKAGES
    ---------------------------------------- */
    useEffect(() => {
        fetch(`${API_BASE}/api/get_packages.php`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setOptions(data.packages);
                }
            })
            .catch(() => { });
    }, []);



    const toggleSelect = (id) => {
        const plan = options.find(o => o.id === id);

        // already purchased (by feature key OR owned package id) -> do nothing
        if (isPackagePurchased(plan)) {
            return;
        }

        setSelected(prev =>
            prev.includes(id)
                ? prev.filter(x => x !== id)
                : [...prev, id]
        );
    };



    useEffect(() => {
        if (!listinguid) return;

        fetch(`${API_BASE}/api/get_payment_history.php?listinguid=${listinguid}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) setPaymentHistory(data.history);
            });
    }, [listinguid]);

    const promotionPrice =
        (options.find(p => (p.upgrade_column || "") === "promotion")
            || options.find(p => p.title === "Promotion"))?.price || 0;

   



    const packageTotal = selected.reduce((sum, id) => {
        const opt = options.find(o => o.id === id);
        if (!opt) return sum;

        // skip already purchased packages
        if (isPackagePurchased(opt)) {
            return sum;
        }

        return sum + (opt.price || 0);
    }, 0);

    const promotionTotal = purchasedPromo ? 0 : promotionDays * promotionPrice;

    const finalAmount = packageTotal + promotionTotal;


    /* ----------------------------------------
       PAYMENT INIT
    ---------------------------------------- */
    const handleProceed = async () => {

        if (!listinguid) {
            alert("Invalid listing selected.");
            return;
        }

        if (selected.length === 0 && promotionDays <= 0) {
            alert("Please select a package or enter promotion days.");
            return;
        }

        // Wallet validation
        if (paymentMethod === "wallet") {
            if (walletBalance < finalAmount) {
                alert("Insufficient wallet walletBalance");
                return;
            }
        }

        setLoading(true);

        try {
            // ================= WALLET PAYMENT =================
            if (paymentMethod === "wallet") {

                const res = await fetch(`${API_BASE}/api/pay_with_wallet.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        listinguid,
                        user_id: listinguid,
                        selected_plans: getFilteredSelectedPlans(),


                        promotion_days: promotionDays,
                        promotion_start: promoStartDate,
                        promotion_end: promoEndDate,
                        amount: finalAmount
                    })
                });

                const data = await res.json();
                setLoading(false);

                if (data.success) {
                    setToast({
                        show: true,
                        message: "Payment successful using wallet",
                        type: "success",
                        duration: 3500
                    });
                    refreshAfterPayment();

                    const url = new URL(window.location.href);
                    url.searchParams.delete("payment");
                    url.searchParams.delete("page");
                    window.history.replaceState({}, "", url);
                    setSelected([]);               // reset selection
                    setUpgradeRefreshKey(x => x + 1);
                } else {
                    alert(data.message || "Wallet payment failed");
                }

                return;
            }

            // ================= BANK PAYMENT (EXISTING) =================
            const res = await fetch(
                `${API_BASE}/api/generate_fonepay_payment.php`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        listinguid,
                        selected_plans: getFilteredSelectedPlans(),

                        promotion_days: promotionDays,
                        promotion_start: promoStartDate,
                        promotion_end: promoEndDate,
                        total_amount: finalAmount,
                        user_id: personaluid,
                    }),
                }
            );

            const data = await res.json();
            setLoading(false);

            if (data.success && data.payment_url) {
                window.location.href = data.payment_url;
            } else {
                alert(data.message || "Payment initialization failed");
            }

        } catch {
            setLoading(false);
            alert("Network error");
        }
    };


    const planOptions = options.filter(opt => (opt.upgrade_column || "") !== "promotion" && opt.title !== "Promotion");

    // ---- Promotion date preview (UI only) ----
    const promotionPreview = (() => {
        if (promotionDays <= 0) return null;

        const start = new Date(); // today
        const end = new Date();
        end.setDate(start.getDate() + promotionDays);

        return {
            start: start.toLocaleDateString(),
            end: end.toLocaleDateString()
        };
    })();

    return (
        <div className="container-fluid py-3" style={{ maxWidth: "1100px" }}>

            {/* TOAST */}
            {toast.show && (
                <div className={`custom-toast ${toast.type}`}>
                    <div className="toast-icon">
                        {toast.type === "success" && "✔"}
                        {toast.type === "danger" && "✖"}
                        {toast.type === "info" && "ℹ"}
                    </div>

                    <div className="toast-content">
                        <div className="toast-title">
                            {toast.type === "success" ? "Success" :
                                toast.type === "danger" ? "Error" : "Info"}
                        </div>
                        <div className="toast-message">{toast.message}</div>
                    </div>

                    <button
                        className="toast-close"
                        onClick={() => setToast({ ...toast, show: false })}
                    >
                        ×
                    </button>

                    <div
                        className="toast-progress"
                        style={{ animationDuration: `${toast.duration}ms` }}
                    />
                </div>
            )}


            <h5 className="fw-bold mb-3 text-center">
                Upgrade Your Listing
            </h5>

            {/* ================= AVAILABLE PACKAGES ================= */}
            <div className="card shadow-sm mb-3 upgrade-packages-card">
                <div className="card-header bg-light fw-semibold">
                    Available Upgrade Packages
                </div>

                <div className="card-body">
                    {planOptions.length === 0 ? (
                        <div className="text-center text-muted py-4">
                            <i className="bi bi-inbox" style={{ fontSize: "2rem" }}></i>
                            <p className="mt-2 mb-0">No packages available at the moment</p>
                        </div>
                    ) : (
                        <div className="row g-3">
                            {planOptions.map(plan => {
                                const planKey = getPlanKey(plan.title);
                                const purchasedItem = purchased.find(p => p.key === planKey) || owned.find(o => o.id === plan.id);
                                const isPurchased = Boolean(purchasedItem);
                                const isSelected = selected.includes(plan.id);

                                // Parse features if they exist
                                const features = plan.features
                                    ? plan.features.split(',').map(f => f.trim()).filter(f => f)
                                    : [];

                                const durationText = plan.duration
                                    ? `${plan.duration} days`
                                    : 'Lifetime';

                                return (
                                    <div className="col-12 col-md-6 col-lg-4" key={plan.id}>
                                        <div
                                            className={`pkg-card ${isPurchased ? "is-purchased" : ""} ${isSelected ? "is-selected" : ""}`}
                                            onClick={() => {
                                                if (!isPurchased) toggleSelect(plan.id);
                                            }}
                                        >
                                            <div className="pkg-card-top">
                                                <span className="pkg-icon">
                                                    <i className="bi bi-box-seam"></i>
                                                </span>
                                                <span className={`pkg-duration-badge ${plan.duration ? "" : "lifetime"}`}>
                                                    {durationText}
                                                </span>
                                            </div>

                                            <h6 className="pkg-title">
                                                {plan.title}
                                                {isPurchased && (
                                                    <span className="pkg-active-badge">
                                                        <i className="bi bi-check-circle-fill"></i> Active
                                                    </span>
                                                )}
                                            </h6>

                                            {plan.description && (
                                                <p className="pkg-desc">{plan.description}</p>
                                            )}

                                            {features.length > 0 && (
                                                <ul className="pkg-features">
                                                    {features.slice(0, 4).map((feature, idx) => (
                                                        <li key={idx}>
                                                            <i className="bi bi-check2"></i>
                                                            <span>{feature}</span>
                                                        </li>
                                                    ))}
                                                    {features.length > 4 && (
                                                        <li className="pkg-more">
                                                            +{features.length - 4} more features
                                                        </li>
                                                    )}
                                                </ul>
                                            )}

                                            {isPurchased && purchasedItem && (
                                                <div className="pkg-valid-till">
                                                    <i className="bi bi-calendar-check"></i>
                                                    Valid till <b>{purchasedItem.end}</b>
                                                </div>
                                            )}

                                            <div className="pkg-card-footer">
                                                <div className="pkg-price">
                                                    <span>Rs. {plan.price.toLocaleString()}</span>
                                                    {plan.duration && (
                                                        <small>≈ ₹{(plan.price / plan.duration).toFixed(2)}/day</small>
                                                    )}
                                                </div>

                                                <button
                                                    type="button"
                                                    className={`pkg-select-btn ${isPurchased ? "purchased" : isSelected ? "selected" : ""}`}
                                                    disabled={isPurchased}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (!isPurchased) toggleSelect(plan.id);
                                                    }}
                                                >
                                                    {isPurchased ? "Purchased" : isSelected ? "Selected" : "Select Package"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            {/* ================= PROMOTION ================= */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">
                    Promotion
                </div>

                <div className="card-body">

                    {purchasedPromo && (
                        <div className="alert alert-success small mb-3">
                            <i className="bi bi-check-circle me-1"></i>
                            Promotion already active from
                            <b className="mx-1">{purchasedPromo.start}</b>
                            to
                            <b className="mx-1">{purchasedPromo.end}</b>
                        </div>
                    )}

                    <div className="row g-2 align-items-end">

                        {/* Start Date */}
                        <div className="col-md-4">
                            <label className="form-label small mb-1">
                                Start Date
                            </label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                value={promoStartDate}
                                onChange={(e) => setPromoStartDate(e.target.value)}
                                disabled={!!purchasedPromo}
                            />
                        </div>

                        {/* End Date */}
                        <div className="col-md-4">
                            <label className="form-label small mb-1">
                                End Date
                            </label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                value={promoEndDate}
                                onChange={(e) => setPromoEndDate(e.target.value)}
                                disabled={!!purchasedPromo}
                            />
                        </div>

                        {/* Promotion Days */}
                        <div className="col-md-3">
                            <label className="form-label small mb-1">
                                Promotion Days
                            </label>
                            <input
                                type="number"
                                className="form-control form-control-sm bg-light"
                                value={promotionDays}
                                readOnly
                            />
                        </div>

                        {/* Price */}
                        <div className="col-md-1 text-end">
                            <small className="text-muted">₹ /day</small>
                            <div className="fw-semibold text-primary">
                                {promotionPrice}
                            </div>
                        </div>
                    </div>

                    {/* PREVIEW */}
                    {!purchasedPromo && promotionDays > 0 && promoStartDate && promoEndDate && (
                        <div className="mt-3 small text-muted">
                            <i className="bi bi-calendar-check me-1 text-success"></i>
                            Active from <b>{promoStartDate}</b> to <b>{promoEndDate}</b>
                            <span className="ms-1">({promotionDays} days)</span>
                            <span className="ms-2 fw-semibold text-dark">
                                Total: ₹ {promotionDays * promotionPrice}
                            </span>
                        </div>
                    )}
                </div>
            </div>

            {/* ================= PAYMENT METHOD ================= */}
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">
                    Select Payment Method
                </div>

                <div className="card-body">
                    <div className="d-flex gap-4">

                        {/* WALLET */}
                        <div
                            className={`border rounded p-3 flex-fill cursor-pointer ${paymentMethod === "wallet" ? "border-success bg-success-subtle" : ""
                                }`}
                            onClick={() => setPaymentMethod("wallet")}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="fw-semibold">Wallet</div>
                            <small className="text-muted">
                                walletBalance: ₹ {walletBalance.toLocaleString()}
                            </small>

                            {walletBalance < finalAmount && (
                                <div className="text-danger small mt-1">
                                    Insufficient wallet walletBalance
                                </div>
                            )}
                        </div>

                        {/* BANK */}
                        <div
                            className={`border rounded p-3 flex-fill cursor-pointer ${paymentMethod === "bank" ? "border-primary bg-primary-subtle" : ""
                                }`}
                            onClick={() => setPaymentMethod("bank")}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="fw-semibold">Bank / FonePay</div>
                            <small className="text-muted">
                                Pay using bank account
                            </small>
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= TOTAL & PAYMENT ================= */}
            <div className="card shadow-sm mb-4">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                        <small className="text-muted">Total Payable</small>
                        <h5 className="fw-bold mb-0">₹ {finalAmount}</h5>
                    </div>

                    <button
                        className="btn btn-primary px-4"
                        disabled={loading}
                        onClick={handleProceed}
                    >
                        {loading ? "Processing..." : "Proceed to Payment"}
                    </button>
                </div>
            </div>

            {/* ================= PURCHASED PACKAGES ================= */}

            {/* ================= PAYMENT HISTORY ================= */}
            <div className="card shadow-sm">
                <div className="card-header bg-light fw-semibold">
                    Payment History
                </div>
                <div className="card-body p-0">
                    <table className="table table-sm mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Invoice</th>

                                <th>Date</th>
                                <th>Transaction</th>
                                <th>Details</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentHistory.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted py-3">
                                        No payment records found
                                    </td>
                                </tr>
                            ) : (
                                paymentHistory.map((p, i) => (
                                    <tr key={i}>
                                        <td>
                                            {p.invoice_no ? (
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#2563eb", cursor: "pointer" }}
                                                    onClick={() =>
                                                        window.open(
                                                            `${API_BASE}/api/download_invoice.php?invoice=${p.invoice_no}`,
                                                            "_blank"
                                                        )
                                                    }
                                                >
                                                    #{p.invoice_no}
                                                </span>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>

                                        <td>{p.date}</td>
                                        <td className="fw-semibold">{p.transaction_id}</td>
                                        <td>
                                            <div className="small">
                                                <b>Packages:</b> {p.packages.join(", ")}
                                            </div>
                                            {p.promotion?.days > 0 && (
                                                <div className="small text-muted">
                                                    Promotion: {p.promotion.days} days
                                                    ({p.promotion.from} → {p.promotion.to})
                                                </div>
                                            )}
                                        </td>
                                        <td className="fw-bold">₹ {p.amount}</td>
                                        <td>
                                            <span className={`badge ${p.status === "SUCCESS"
                                                ? "bg-success"
                                                : "bg-danger"
                                                }`}>
                                                {p.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>


            {/* ================= STYLES ================= */}
            <style>{`
                /* ---- Package cards (grid) ---- */
                .upgrade-packages-card .card-body {
                    background: #fafbfc;
                }

                .pkg-card {
                    position: relative;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    background: #fff;
                    border: 1px solid #e5e9f0;
                    border-radius: 12px;
                    padding: 1.1rem 1.15rem;
                    cursor: pointer;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
                }

                .pkg-card:hover:not(.is-purchased) {
                    border-color: #93c5fd;
                    box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);
                    transform: translateY(-2px);
                }

                .pkg-card.is-selected {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
                }

                .pkg-card.is-purchased {
                    border-color: #86efac;
                    background: #f6fdf8;
                    cursor: not-allowed;
                }

                .pkg-card-top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 0.6rem;
                }

                .pkg-icon {
                    width: 34px;
                    height: 34px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #eef4ff;
                    color: #2563eb;
                    font-size: 1rem;
                }

                .pkg-duration-badge {
                    font-size: 0.7rem;
                    font-weight: 600;
                    padding: 0.2rem 0.55rem;
                    border-radius: 999px;
                    background: #e0f2fe;
                    color: #0369a1;
                    white-space: nowrap;
                }

                .pkg-duration-badge.lifetime {
                    background: #fef3c7;
                    color: #92400e;
                }

                .pkg-title {
                    font-weight: 700;
                    font-size: 0.98rem;
                    margin-bottom: 0.35rem;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.4rem;
                }

                .pkg-active-badge {
                    font-size: 0.68rem;
                    font-weight: 600;
                    color: #16a34a;
                    background: #dcfce7;
                    border-radius: 999px;
                    padding: 0.15rem 0.5rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.25rem;
                }

                .pkg-desc {
                    font-size: 0.8rem;
                    color: #6b7280;
                    margin-bottom: 0.6rem;
                }

                .pkg-features {
                    list-style: none;
                    padding: 0;
                    margin: 0 0 0.75rem 0;
                    flex-grow: 1;
                }

                .pkg-features li {
                    display: flex;
                    align-items: flex-start;
                    gap: 0.4rem;
                    font-size: 0.8rem;
                    color: #374151;
                    margin-bottom: 0.3rem;
                }

                .pkg-features li i {
                    color: #16a34a;
                    margin-top: 0.15rem;
                    flex-shrink: 0;
                }

                .pkg-features .pkg-more {
                    color: #2563eb;
                    font-size: 0.75rem;
                    font-weight: 600;
                }

                .pkg-valid-till {
                    font-size: 0.75rem;
                    color: #16a34a;
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    margin-bottom: 0.6rem;
                }

                .pkg-card-footer {
                    margin-top: auto;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-top: 0.6rem;
                    border-top: 1px dashed #e5e9f0;
                }

                .pkg-price {
                    display: flex;
                    flex-direction: column;
                    line-height: 1.1;
                }

                .pkg-price span {
                    font-weight: 700;
                    font-size: 1.05rem;
                    color: #2563eb;
                }

                .pkg-price small {
                    color: #9ca3af;
                    font-size: 0.7rem;
                }

                .pkg-select-btn {
                    border: 1px solid #2563eb;
                    background: #fff;
                    color: #2563eb;
                    font-size: 0.78rem;
                    font-weight: 600;
                    padding: 0.35rem 0.8rem;
                    border-radius: 7px;
                    transition: all 0.15s ease;
                    white-space: nowrap;
                }

                .pkg-select-btn:hover:not(:disabled) {
                    background: #2563eb;
                    color: #fff;
                }

                .pkg-select-btn.selected {
                    background: #2563eb;
                    color: #fff;
                }

                .pkg-select-btn.purchased,
                .pkg-select-btn:disabled {
                    border-color: #86efac;
                    background: #dcfce7;
                    color: #16a34a;
                    cursor: not-allowed;
                }

                .custom-toast {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    min-width: 320px;
                    max-width: 420px;
                    background: #fff;
                    border-radius: 10px;
                    padding: 14px 16px;
                    box-shadow: 0 12px 30px rgba(0,0,0,0.12);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    z-index: 9999;
                    animation: slideIn 0.35s ease-out;
                }

                .custom-toast.success {
                    border-left: 5px solid #22c55e;
                }

                .custom-toast.danger {
                    border-left: 5px solid #ef4444;
                }

                .custom-toast.info {
                    border-left: 5px solid #3b82f6;
                }

                .toast-icon {
                    width: 34px;
                    height: 34px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 16px;
                    color: #fff;
                }

                .custom-toast.success .toast-icon {
                    background: #22c55e;
                }

                .custom-toast.danger .toast-icon {
                    background: #ef4444;
                }

                .custom-toast.info .toast-icon {
                    background: #3b82f6;
                }

                .toast-content {
                    flex: 1;
                }

                .toast-title {
                    font-weight: 600;
                    font-size: 14px;
                    margin-bottom: 2px;
                }

                .toast-message {
                    font-size: 13px;
                    color: #555;
                }

                .toast-close {
                    border: none;
                    background: transparent;
                    font-size: 18px;
                    cursor: pointer;
                    color: #999;
                }

                .toast-close:hover {
                    color: #000;
                }

                .toast-progress {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #60a5fa, #22c55e);
                    animation: progress linear forwards;
                    width: 100%;
                }

                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateX(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }

                @keyframes progress {
                    from { width: 100%; }
                    to { width: 0%; }
                }
            `}</style>
        </div>
    );
}